import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const getIsUserEmailRegistered: UseCase<AuthRepository, 'getIsUserRegistered'> = repository => {
  return async email => {
    return await repository.getIsUserRegistered(email)
  }
}
